// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  loading: false,
  bookshopCustomer: {},
  isOpenConfirmModal: false,
  value: '',
  valueStatus: {
    status: true,
    message: null,
  }
};

const voucherConfirmedReducer = createReducer(initialState, {
  [types.VOUCHER_CONFIRMED_START_LOADING](state) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.VOUCHER_CONFIRMED_STOP_LOADING](state) {
    return {
      ...state,
      loading: false,
    };
  },
  [types.VOUCHER_CONFIRMED_SET_BOOKSHOP_CUSTOMER](state, action) {
    return {
      ...state,
      bookshopCustomer: action.payload,
    };
  },
  [types.VOUCHER_CONFIRMED_CHANGE_REDEEM_VALUE](state, action) {
    return {
      ...state,
      [action.field]: action.value,
      valueStatus: initialState.valueStatus,
    };
  },
  [types.VOUCHER_CONFIRMED_VALIDATE_REDEEM_VALUE](state, action) {
    return {
      ...state,
      valueStatus: action.payload,
    };
  },
  [types.VOUCHER_CONFIRMED_RESET_FORM](state) {
    return {
      ...state,
      value: initialState.value,
      valueStatus: initialState.valueStatus,
    };
  },
  [types.VOUCHER_CONFIRMED_OPEN_CONFIRM_MODAL](state) {
    return {
      ...state,
      isOpenConfirmModal: true,
    };
  },
  [types.VOUCHER_CONFIRMED_CLOSE_CONFIRM_MODAL](state) {
    return {
      ...state,
      isOpenConfirmModal: false
    };
  },
  [types.VOUCHER_CONFIRMED_REDEEM_VOUCHER_SUCCESS](state, action) {
    return {
      ...state,
      bookshopCustomer: {
        ...state.bookshopCustomer,
        Balance: action.payload,
      }
    };
  },
});

export default voucherConfirmedReducer;
